function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 0.5,
  x2: 0.5,
  y2: 1,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3c00dc"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#274cdf"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 297"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 373",
  d: "M6182.558-5500.276c168.719-32.451 308.325 52.711 315.159 167.165s-99.285 242.349-256.807 242.524-209.726-131.375-501.785-97.819-441.71-10.8-465.175-98.536 51.322-215.271 337.25-104.533 402.639-76.35 571.358-108.801z",
  transform: "translate(-5269.922 5580.77)",
  fill: "url(#a)"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 378",
  d: "M338.606 329.228c144.719 33.75 233.724-76.178 321.055-36.9s180.248-121.266 321.9-94.715",
  fill: "none",
  stroke: "#d3daee",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 174",
  transform: "rotate(14.98 409.085 523.769)",
  stroke: "#3c00dc",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 276",
  d: "M265.931 462.588h83.752V291.049c0-171.546-83.752-247.022-83.752-247.022s-83.754 75.473-83.754 247.022v171.539h83.758z",
  fill: "#fff",
  strokeWidth: 2.5
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 72",
  cx: 43.561,
  cy: 43.561,
  r: 43.561,
  transform: "translate(222.366 242.732)",
  strokeWidth: 2,
  fill: "#00dce6"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 277",
  d: "M322.997 462.587v27.033H209.285v-27.033",
  fill: "#fff",
  strokeWidth: 2.5
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 26",
  fill: "none",
  strokeWidth: 2.5,
  d: "M182.789 406.206h123.038"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 279",
  d: "M182.173 365.947S91.91 416.863 66.582 533.194h22.954s48.892-54.959 92.636-70.609",
  fill: "#fff",
  strokeWidth: 2.5
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 280",
  d: "M349.682 365.947s90.269 50.916 115.591 167.247h-22.948s-48.892-54.959-92.643-70.609",
  fill: "#fff",
  strokeWidth: 2.5
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 27",
  fill: "none",
  strokeWidth: 2.5,
  d: "M340.09 195.193h-85.419"
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 302",
  d: "M177.752 219.019l-5.465.369a27.45 27.45 0 00-25.559 25.559l-.368 5.476a.577.577 0 01-1.153 0l-.369-5.476a27.45 27.45 0 00-25.56-25.559l-5.464-.369a.542.542 0 010-1.084l5.464-.369a27.45 27.45 0 0025.56-25.559l.369-5.465a.577.577 0 111.153 0l.368 5.465a27.451 27.451 0 0025.574 25.56l5.464.369a.542.542 0 11-.012 1.084z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 377",
  d: "M1053.202 416.92l-3.3.223a16.572 16.572 0 00-15.43 15.43l-.222 3.306a.35.35 0 01-.7 0l-.223-3.306a16.572 16.572 0 00-15.43-15.43l-3.3-.223a.327.327 0 010-.654l3.3-.223a16.572 16.572 0 0015.43-15.43l.223-3.3a.35.35 0 11.7 0l.222 3.3a16.572 16.572 0 0015.43 15.43l3.3.223a.327.327 0 11-.007.654z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 303",
  d: "M598.802 452.641l-2.757.186a13.848 13.848 0 00-12.894 12.894l-.186 2.763a.291.291 0 01-.582 0l-.186-2.763a13.848 13.848 0 00-12.895-12.894l-2.757-.186a.274.274 0 010-.547l2.757-.186a13.848 13.848 0 0012.895-12.894l.186-2.757a.291.291 0 01.582 0l.186 2.757a13.849 13.849 0 0012.9 12.894l2.757.186a.274.274 0 11-.006.547z",
  fill: "#d3daee"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 379",
  d: "M626.891 325.536l-1.747.118a8.778 8.778 0 00-8.173 8.173l-.118 1.751a.184.184 0 01-.369 0l-.118-1.751a8.778 8.778 0 00-8.173-8.173l-1.747-.118a.173.173 0 010-.347l1.747-.118a8.778 8.778 0 008.173-8.173l.118-1.747a.184.184 0 11.369 0l.118 1.747a8.778 8.778 0 008.177 8.173l1.747.118a.173.173 0 110 .347z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 304",
  d: "M241.802 29.641l-2.757.186a13.848 13.848 0 00-12.894 12.894l-.186 2.763a.291.291 0 01-.582 0l-.186-2.763a13.848 13.848 0 00-12.895-12.894l-2.757-.186a.274.274 0 010-.547l2.757-.186a13.848 13.848 0 0012.895-12.894l.186-2.757a.291.291 0 01.582 0l.186 2.757a13.849 13.849 0 0012.9 12.894l2.757.186a.274.274 0 11-.006.547z",
  fill: "#d3daee"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 375",
  d: "M720.802 120.641l-2.757.186a13.848 13.848 0 00-12.894 12.894l-.186 2.763a.291.291 0 01-.582 0l-.186-2.763a13.848 13.848 0 00-12.895-12.894l-2.757-.186a.274.274 0 010-.547l2.757-.186a13.848 13.848 0 0012.895-12.894l.186-2.757a.291.291 0 01.582 0l.186 2.757a13.849 13.849 0 0012.9 12.894l2.757.186a.274.274 0 11-.006.547z",
  fill: "#d3daee"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 374",
  d: "M103.045 278.69l-2.269.153a11.4 11.4 0 00-10.613 10.611l-.153 2.274a.24.24 0 11-.479 0l-.153-2.274a11.4 11.4 0 00-10.613-10.612l-2.269-.153a.225.225 0 010-.45l2.269-.153a11.4 11.4 0 0010.613-10.612l.153-2.269a.24.24 0 11.479 0l.153 2.269a11.4 11.4 0 0010.618 10.612l2.269.153a.225.225 0 110 .45z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 376",
  d: "M1141.045 186.69l-2.269.153a11.4 11.4 0 00-10.613 10.611l-.153 2.274a.24.24 0 11-.479 0l-.153-2.274a11.4 11.4 0 00-10.613-10.612l-2.269-.153a.225.225 0 010-.45l2.269-.153a11.4 11.4 0 0010.613-10.612l.153-2.269a.24.24 0 11.479 0l.153 2.269a11.4 11.4 0 0010.618 10.612l2.269.153a.225.225 0 110 .45z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 293"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 305",
  d: "M1007.419 321.141l40.91 17.993c3.048 1.225 18.117-10.07 19.717-13.012l38.26-79.119c4.772-8.3 1.96-21.524-5.1-22.421l-82.157-12.577a3.889 3.889 0 00-4.6 2.7l-27.868 91.208z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 306",
  d: "M1103.36 230.519l-62.538 115.094a8.867 8.867 0 01-11.112 4.1l-56.9-24.751-9.539-6.86-19.658-14.133 38.841-118.108a5.019 5.019 0 016.137-3.134l91.743 21.268 10.627 2.464 2.271.527c9.022 1.422 15.814 13.393 10.128 23.533z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 307",
  d: "M1091.996 216.286l-64.481 120.834a8.861 8.861 0 01-11.11 4.1l-53.133-23.114-19.658-14.133 38.841-118.108a5.019 5.019 0 016.137-3.134l91.743 21.268c4.1.649 8.066 1.152 10.627 2.464 3.067 1.562 4.131 4.292 1.034 9.823z",
  fill: "#d3daee"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 308",
  d: "M989.966 249.799a71.2 71.2 0 01-23.8 11.3c-7.9 2.137-30.06 6.522-35.068-4-4.933-10.363-11.2-21.713-14.357-33.389-3.716-13.738-3.4-34.047 11.935-37.84 14.974-3.7 19.525 6.184 22.659 19.614.432 1.85.834 3.711 1.265 5.56 2.244 9.618 2.67 9.244 4.017 8.9 0 0 12.6-8.385 21.735-10.734 12.585-3.236 21.115 3.459 22.895 12.859 1.859 9.851-3.58 21.987-11.281 27.73z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 309",
  d: "M928.081 171.856a38.151 38.151 0 00-1.353-6.929c-.884-3.27-3.639-9.831-4.557-13.227-2.112-7.81-3.167-13 3.1-14.7a4.51 4.51 0 015.481 4.425c.243 3.237 1.833 13.276 2.156 13.188.362-.1.938.14 1.272.05a.318.318 0 00.211-.164c2.9-5.627.544-15.783 7.239-17.594 2.9-.783 6.97 1.219 5.518 8.4-.294 1.457-5.51 26.766-11.366 28.35a8.858 8.858 0 01-7.701-1.799z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 310",
  d: "M910.257 173.743a11.438 11.438 0 01.571 1.632c1.069 3.955.314 8.531 1.347 12.35 1.95 7.212 12.1 11.627 22.437 8.833 12.3-3.328 12.48-12.175 17.776-19.786a10.081 10.081 0 001.661-8.684c-1.648-6.094-9.308-11.6-12.244-10.807a4.942 4.942 0 00-3.552 5.947 7.458 7.458 0 002.67 3.688c-19.538-9.957-16.124-12.358-20.823-11.088-4.062 1.1-5.716 5.156-4.691 8.943a6.121 6.121 0 00-3.222-.015c-2.6.7-3.938 2.864-3.081 6.036a21.231 21.231 0 001.151 2.951z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 311",
  d: "M936.513 317.381c-.674-.756-41.88-21.28-41.88-21.28s-36.087 37.44-45.013 41.731-21.248-10.909-28.025-17.755-18.8-23.535-14.675-29.107 15.389-8.15 21.422-5.793 12.621 5.031 12.621 5.031 23.3-39.612 41.775-41.559 78.419 33.214 78.419 33.214z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 312",
  d: "M919.084 388.591s-19.739 10.918-15.8 25.478c2.438 9.013 23.639 6.255 29.945 3.434s30.025-19.652 30.136-27.495-4.055-48.007-4.055-48.007 20.915 14.06 36.036 12.2 28.892-19.718 32.4-27.364 33.419-60.747 35.61-69.151-.911-15.75-5.719-21.146-57.007-25.125-62.684-25.456c-13.4-.78-23.977 10.094-30.2 20.86-2.343 4.053-23.045 48.6-20.026 49.269 0 0-20.21-4.579-29.849 10.676s-5.426 48.712-2.8 58.418 7.006 38.284 7.006 38.284z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 313",
  d: "M1044.157 244.021a35.283 35.283 0 00-10.648 33.579c.154.689.326 1.351.516 1.976 2.662 8.747 3.807 13.091 4.984 18.473s15.756 30.541 16.152 33.1 1.6 8.879-1.659 12.127-3.325 6.845-1.035 9.776c1.7 2.168 6.881-1.747 9.462-3.929a1.448 1.448 0 01.585-.308 1.5 1.5 0 011.741.826c1.782 3.872 3.584 7.68 4.107 13.249.428 4.557-2.514 8.323-2.364 12.075.119 2.948 4.932 4.918 7.9.628 1.255 1.865 7.939 2.042 10.2-2.759l2.25-4.465s9.445-9.169 6.984-19.187c-2.116-8.611-10.009-21.213-10.009-21.213s-2.777-28.493-5.518-36.655c-3.378-10.06-10.518-14.812-9-24.393s-.058-19.773-4.37-25.871a16.757 16.757 0 00-6.665-5.687 4.635 4.635 0 00-5.078.8z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 323",
  d: "M1043 231.444a39.79 39.79 0 01-47.913-25.148 33.779 33.779 0 01-.517-1.566 37.86 37.86 0 01-.381-1.314 39.8 39.8 0 0121-46.183 40.212 40.212 0 017.033-2.626 39.8 39.8 0 0120.781 76.838z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 324",
  d: "M1052.984 207.905c-6.528 17.374-28.927 8.542-51.059.226a54.323 54.323 0 01-7.356-3.4 37.86 37.86 0 01-.381-1.314 39.8 39.8 0 0121-46.183c14.921 3.139 24.758 8 31.027 13.673 12.74 11.536 10.742 26.424 6.769 36.998z",
  fill: "#00dce6"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 325",
  d: "M1043.81 192.305c-6.522 17.36-28.895 8.555-51.008.245a39.885 39.885 0 0115.706-31.209 39.47 39.47 0 016.677-4.109c14.921 3.139 24.758 8 31.027 13.673 1.564 7.588-.083 15.229-2.402 21.4z",
  fill: "#fff",
  opacity: 0.385
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 326",
  d: "M1070.819 336.268l6.391 13.069a1.8 1.8 0 001.6 1.007l14.771.115s2.1.135-1.224-8.323c-3.887-9.9-6.479-9.822-6.479-9.822a32.384 32.384 0 00-8.41.394 38.58 38.58 0 00-5.833 1.593 1.418 1.418 0 00-.816 1.967z",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 294",
  transform: "translate(-2394.758 -4317.709)"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 245"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 321",
  d: "M3244.629 4652.537a1.019 1.019 0 01-.982-.752c-3.055-11.3-22.957-40.186-36.089-44.4a1.018 1.018 0 01.622-1.938c14.165 4.542 34.306 34.242 37.432 45.8a1.018 1.018 0 01-.717 1.249 1.045 1.045 0 01-.266.041z",
  fill: "#3c00dc"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 246"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 322",
  d: "M3312.106 4731.821a27.135 27.135 0 01-11.618-2.595 1.018 1.018 0 01.863-1.844 26.157 26.157 0 0018.381 1.348c12.542-3.392 24.17-14.03 33.891-23.99a1.018 1.018 0 111.457 1.422c-9.913 10.156-21.8 21.013-34.816 24.533a31.187 31.187 0 01-8.158 1.126z",
  fill: "#3c00dc"
})), /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 89",
  cx: 5.566,
  cy: 3.47,
  rx: 5.566,
  ry: 3.47,
  transform: "rotate(-63.104 5414.83 -542.023)",
  fill: "#3c00dc"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 247"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 327",
  d: "M3405.983 4637.237a1.017 1.017 0 01-.873-.492c-.047-.079-4.787-7.87-10.1-11.084-4.33-2.622-37.405-18.034-50.7-23.466-9.595-3.92-17.8-4.116-24.387-.583-10.728 5.753-13.617 19.572-13.646 19.711a1.02 1.02 0 01-2-.4c.122-.605 3.115-14.9 14.679-21.1 7.148-3.833 15.936-3.667 26.119.493 13.352 5.454 46.616 20.962 50.988 23.609 5.741 3.477 10.582 11.438 10.785 11.775a1.018 1.018 0 01-.871 1.543z",
  fill: "#3c00dc"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 248"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 328",
  d: "M3372.24 4653.354a1.018 1.018 0 01-.689-1.767 29.722 29.722 0 009.592-21.081 22.378 22.378 0 00-.942-6.5 1.018 1.018 0 111.948-.59 24.409 24.409 0 011.03 7.089 31.817 31.817 0 01-10.249 22.579 1.016 1.016 0 01-.69.27z",
  fill: "#3c00dc"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 249"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 329",
  d: "M3384.231 4643.68a1.018 1.018 0 01-.932-1.426 29.392 29.392 0 002.155-11.922c0-1.011-.033-2.087-.1-3.2a1.018 1.018 0 012.032-.12c.068 1.153.1 2.27.1 3.32a31.362 31.362 0 01-2.326 12.738 1.018 1.018 0 01-.929.61z",
  fill: "#3c00dc"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 250"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 330",
  d: "M3324.929 4594.466a1.021 1.021 0 01-1.011-1.145 9.845 9.845 0 00.073-1.22 24.079 24.079 0 00-.968-5.743 1.018 1.018 0 111.975-.494 25.946 25.946 0 011.029 6.237 11.936 11.936 0 01-.089 1.473 1.018 1.018 0 01-1.009.892z",
  fill: "#3c00dc"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 251"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 331",
  d: "M3329.209 4593.548a1.017 1.017 0 01-1.011-1.144 6.581 6.581 0 00.052-.809 8.143 8.143 0 00-1.722-4.614 1.018 1.018 0 111.694-1.129 10.141 10.141 0 012.064 5.744 8.592 8.592 0 01-.067 1.061 1.018 1.018 0 01-1.01.891z",
  fill: "#3c00dc"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 252"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 332",
  d: "M3284.744 4619.595a1.017 1.017 0 01-.932-.608c-6.842-15.54-18.406-27.782-31.728-33.586a1.018 1.018 0 01.813-1.866c13.786 6.006 25.733 18.628 32.778 34.632a1.018 1.018 0 01-.931 1.428z",
  fill: "#3c00dc"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 253"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 333",
  d: "M3322.064 4685.159a30.331 30.331 0 01-12.8-2.679 1.018 1.018 0 11.85-1.85c6.474 2.975 14.176 3.287 22.892.93a69.452 69.452 0 0021.673-10.634 1.018 1.018 0 011.187 1.654 71.515 71.515 0 01-22.328 10.945 44.015 44.015 0 01-11.474 1.634z",
  fill: "#3c00dc"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 254"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 334",
  d: "M3427.397 4620.884c-7.1 0-42.675-10.391-84.456-34.856a1.018 1.018 0 011.029-1.756 361.687 361.687 0 0055.928 26.824c15.645 5.814 25.267 7.841 27.659 7.75a1.018 1.018 0 11.076 2.034c-.075.004-.154.004-.236.004z",
  fill: "#3c00dc"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 255"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 335",
  d: "M3420.282 4610.866a1 1 0 01-.268-.036c-2.575-.7-5.224-1.495-7.872-2.355a1.018 1.018 0 11.628-1.936c2.618.851 5.234 1.634 7.779 2.328a1.018 1.018 0 01-.268 2z",
  fill: "#3c00dc"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 256"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 336",
  d: "M3423.028 4583.628a1 1 0 01-.247-.031 1.017 1.017 0 01-.741-1.234c1.823-7.291 6.708-14.585 13.4-20.013 6.861-5.564 14.76-8.628 22.241-8.628.468 0 .938.013 1.4.037a1.018 1.018 0 11-.107 2.032 25.043 25.043 0 00-1.291-.034c-14.326 0-30.059 12.663-33.668 27.1a1.018 1.018 0 01-.987.771z",
  fill: "#3c00dc"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 257"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 337",
  d: "M3427.642 4564.9a1.018 1.018 0 01-.735-1.722c7.793-8.132 15.441-12.67 23.381-13.873a1.018 1.018 0 11.305 2.013c-7.479 1.133-14.746 5.473-22.216 13.269a1.016 1.016 0 01-.735.313z",
  fill: "#3c00dc"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 258"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 338",
  d: "M3348.931 4571.685a1.017 1.017 0 01-.881-1.526c2.35-4.079 4.379-8.484 6.526-13.148 6.164-13.389 12.537-27.233 26.838-32.622a1.018 1.018 0 11.718 1.9c-13.52 5.094-19.716 18.553-25.707 31.568-2.072 4.5-4.214 9.154-6.611 13.313a1.017 1.017 0 01-.883.515z",
  fill: "#3c00dc"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 259"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 339",
  d: "M3369.827 4543.73a1.018 1.018 0 01-.9-1.489c3.889-7.454 10.967-11.889 16.22-14.3a1.018 1.018 0 01.848 1.851c-4.964 2.275-11.641 6.444-15.264 13.388a1.018 1.018 0 01-.904.55z",
  fill: "#3c00dc"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 260"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 340",
  d: "M3428.586 4547.911a1.009 1.009 0 01-.178-.016l-.891-.157c-11.914-2.1-24.234-4.269-33.726-12.14a1.018 1.018 0 011.3-1.567c9.077 7.528 21.127 9.65 32.78 11.7l.892.157a1.018 1.018 0 01-.176 2.02z",
  fill: "#3c00dc"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 261"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 341",
  d: "M3458.084 4521.199a1.012 1.012 0 01-.523-.146 5.815 5.815 0 00-3.192-.784 1.018 1.018 0 110-2.035 7.8 7.8 0 014.24 1.074 1.018 1.018 0 01-.524 1.891z",
  fill: "#3c00dc"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 262"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 342",
  d: "M3472.325 4540.699a4.124 4.124 0 01-2.514-.8 4.488 4.488 0 01-1.691-3.784 7.948 7.948 0 015.336-7.1 4.488 4.488 0 014.1.572c2.2 1.65 2.244 5.306.107 8.149a6.975 6.975 0 01-5.338 2.963zm2.7-9.9a3.353 3.353 0 00-.977.156 5.922 5.922 0 00-3.895 5.182 2.515 2.515 0 00.879 2.127c1.276.959 3.57.154 5.007-1.759s1.573-4.34.3-5.3a2.144 2.144 0 00-1.314-.403z",
  fill: "#3c00dc"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 263"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 343",
  d: "M3467.124 4551.755a3.408 3.408 0 01-2.067-.663 3.674 3.674 0 01-1.375-3.056 5.955 5.955 0 011.244-3.438c1.723-2.292 4.479-3.03 6.274-1.681a3.676 3.676 0 011.375 3.056 6.242 6.242 0 01-4.2 5.589 4.3 4.3 0 01-1.251.193zm2.008-7.471a3.534 3.534 0 00-2.579 1.538 3.967 3.967 0 00-.836 2.244 1.457 1.457 0 002.064 1.551 4.216 4.216 0 002.758-3.671 1.707 1.707 0 00-.562-1.4 1.381 1.381 0 00-.845-.262z",
  fill: "#3c00dc"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 264"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 344",
  d: "M3474.807 4595.063a1.018 1.018 0 01-.906-1.479l22.763-44.829a1.017 1.017 0 111.814.921l-22.76 44.83a1.017 1.017 0 01-.911.557z",
  fill: "#3c00dc"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 265"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 345",
  d: "M3478.29 4640.589a1.018 1.018 0 01-1.011-.917c-1.464-14.64-8.262-41.88-13.132-55.546a40.5 40.5 0 01-1.712-10.514c-.332-4.448-.675-9.048-2.8-12.843a1.017 1.017 0 111.776-.993c2.34 4.188 2.7 9.015 3.049 13.684a38.418 38.418 0 001.6 9.982c4.91 13.774 11.763 41.249 13.241 56.027a1.017 1.017 0 01-.912 1.114.774.774 0 01-.099.006z",
  fill: "#3c00dc"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 266"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 346",
  d: "M3449.257 4655.919a1.017 1.017 0 01-1-.85 4.514 4.514 0 01-.058-.75 11.105 11.105 0 01.094-1.259c.036-.316.07-.616.08-.9-.664-1.792-6.895-17.163-7.435-18.132-1.412-2.535-2.95-5.1-4.437-7.59-6.218-10.391-12.647-21.136-12.647-33.553a1.018 1.018 0 012.035 0c0 11.855 6.283 22.354 12.359 32.508 1.5 2.5 3.042 5.083 4.468 7.645.414.743 2.738 6.418 4.087 9.735 3.608 8.876 3.608 9 3.608 9.228a11.3 11.3 0 01-.1 1.29 9.447 9.447 0 00-.082 1.029 2.5 2.5 0 00.03.415 1.017 1.017 0 01-.836 1.171 1 1 0 01-.166.013z",
  fill: "#3c00dc"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 267"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 347",
  d: "M3441.591 4625.49a1.018 1.018 0 01-.842-1.588c4.768-7.056 13.144-11.269 22.407-11.269a29.459 29.459 0 015.372.493 1.018 1.018 0 01-.372 2 27.4 27.4 0 00-5-.459c-8.586 0-16.332 3.877-20.721 10.373a1.016 1.016 0 01-.844.45z",
  fill: "#3c00dc"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 268"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 348",
  d: "M3445.076 4627.813a1.018 1.018 0 01-.751-1.7c4.869-5.332 12.145-6.067 18.565-6.715l1.128-.115a1.018 1.018 0 01.209 2.024l-1.134.116c-6.353.641-12.922 1.3-17.266 6.062a1.015 1.015 0 01-.751.328z",
  fill: "#3c00dc"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 269"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 349",
  d: "M3452.279 4647.324a1.018 1.018 0 01-.62-1.825c3.955-3.032 11.847-8.12 20.262-8.12a18.282 18.282 0 016.746 1.245 1.018 1.018 0 11-.748 1.893 16.263 16.263 0 00-6-1.1c-7.814 0-15.272 4.824-19.023 7.7a1.015 1.015 0 01-.617.207z",
  fill: "#3c00dc"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 270"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 350",
  d: "M3469.124 4694.012a1.018 1.018 0 01-.951-1.379c.306-.807.634-1.625.952-2.416a37.142 37.142 0 002.768-9.074 1.018 1.018 0 112.02.252 38.678 38.678 0 01-2.9 9.58 132 132 0 00-.937 2.38 1.018 1.018 0 01-.952.657z",
  fill: "#3c00dc"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 271"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 351",
  d: "M3479.675 4688.667a1.019 1.019 0 01-.927-1.436 17.63 17.63 0 001.493-7.187c0-.272-.006-.547-.019-.816a1.018 1.018 0 012.033-.093c.014.3.021.606.021.909a19.673 19.673 0 01-1.673 8.022 1.018 1.018 0 01-.928.601z",
  fill: "#3c00dc"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 272"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 352",
  d: "M3478.232 4670.15c-8.991 0-11.027-7.218-13.6-16.356a1.018 1.018 0 011.959-.552c2.756 9.773 4.526 14.873 11.646 14.873a41.858 41.858 0 005.609-.538c1.357-.191 2.76-.388 4.1-.483a1.018 1.018 0 01.145 2.03c-1.271.091-2.579.274-3.962.469a43.318 43.318 0 01-5.897.557z",
  fill: "#3c00dc"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 273"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 353",
  d: "M3480.458 4652.191a1.011 1.011 0 01-.344-.061 19.011 19.011 0 00-6.318-1.324 8.274 8.274 0 00-3.35.647 1.018 1.018 0 01-.82-1.863 10.3 10.3 0 014.169-.819 20.954 20.954 0 017.007 1.445 1.018 1.018 0 01-.345 1.976z",
  fill: "#3c00dc"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 274"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 354",
  d: "M3320.6 4517.323a25.319 25.319 0 01-7.282-1.044 1.018 1.018 0 01.585-1.95 23.293 23.293 0 006.7.959c7.256 0 14.356-3.085 19.731-5.772a1.018 1.018 0 01.91 1.821c-5.578 2.787-12.962 5.986-20.644 5.986z",
  fill: "#3c00dc"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 275"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 355",
  d: "M3319.313 4551.187a7.527 7.527 0 01-4.431-1.372 1.018 1.018 0 111.174-1.663 5.459 5.459 0 003.258 1c2.244 0 4.647-1.048 6.971-2.062a90.379 90.379 0 011.572-.673 1.018 1.018 0 11.775 1.882c-.494.2-1 .423-1.534.657-2.399 1.046-5.117 2.231-7.785 2.231z",
  fill: "#3c00dc"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 276"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 356",
  d: "M3320.555 4555.812a16.976 16.976 0 01-2.941-.252 1.018 1.018 0 11.354-2 14.93 14.93 0 002.587.222 22.155 22.155 0 008.24-1.79 1.018 1.018 0 01.756 1.89 24.118 24.118 0 01-8.996 1.93z",
  fill: "#3c00dc"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 277"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 357",
  d: "M3368.482 4578.449a1.019 1.019 0 01-.943-1.4l8.813-21.693-10.466-3.557-9.052 19.3a1.018 1.018 0 01-1.843-.864l9.438-20.125a1.018 1.018 0 011.249-.532l12.349 4.2a1.018 1.018 0 01.615 1.347l-9.219 22.693a1.019 1.019 0 01-.941.631z",
  fill: "#3c00dc"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 278"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 358",
  d: "M3385.086 4585.13a1.018 1.018 0 01-.943-1.4l8.812-21.693-10.466-3.557-9.052 19.3a1.018 1.018 0 01-1.843-.865l9.438-20.124a1.017 1.017 0 011.249-.532l12.35 4.2a1.017 1.017 0 01.615 1.347l-9.218 22.693a1.018 1.018 0 01-.942.631z",
  fill: "#3c00dc"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 279"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 359",
  d: "M3406.225 4583.493q-.184 0-.378-.007a20.282 20.282 0 01-5.3-1.06c-.8-.262-7.781-2.639-6.849-5.486s7.968-.633 8.768-.372a20.318 20.318 0 014.9 2.284c1.626 1.1 2.281 2.18 1.946 3.2-.315.958-1.352 1.441-3.087 1.441zm-10.444-5.87c.5.619 2.293 1.853 5.4 2.869s5.273 1.079 6.047.879c-.5-.619-2.293-1.853-5.4-2.869s-5.274-1.079-6.046-.879z",
  fill: "#3c00dc"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 280"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 360",
  d: "M3401.911 4596.661a1.018 1.018 0 01-.922-1.447l3.594-7.727a1.018 1.018 0 111.845.858l-3.594 7.727a1.017 1.017 0 01-.923.589z",
  fill: "#3c00dc"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 281"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 361",
  d: "M3404.034 4605.569a1.006 1.006 0 01-.323-.053c-2.1-.7-4.145-1.606-6.125-2.482-1.544-.683-3.141-1.389-4.746-1.991-.889-.333-1.87-.622-2.817-.9-.982-.289-2-.588-2.957-.947l-.053-.022c-8.54-3.768-15.823-7.225-22.922-10.882l-2.01-1.08a174.539 174.539 0 01-15.386-8.935 1.018 1.018 0 111.138-1.687 173.092 173.092 0 0015.21 8.829l2 1.072c7.037 3.625 14.278 7.063 22.768 10.809.882.329 1.852.615 2.79.891.983.289 2 .587 2.958.947 1.66.623 3.284 1.341 4.855 2.036 2.026.9 3.939 1.743 5.946 2.414a1.018 1.018 0 01-.322 1.983z",
  fill: "#3c00dc"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 282"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 362",
  d: "M3344.697 4543.983a1.018 1.018 0 01-.646-1.8 16 16 0 004.648-5.778 1.018 1.018 0 011.862.821 18 18 0 01-5.219 6.531 1.017 1.017 0 01-.645.226z",
  fill: "#3c00dc"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 283"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 363",
  d: "M3350.748 4546.071h-.059a1.017 1.017 0 01-.957-1.075c.049-.859.128-1.744.2-2.6.137-1.545.279-3.142.261-4.684a1.018 1.018 0 112.035-.024 48.934 48.934 0 01-.269 4.888c-.078.879-.152 1.71-.2 2.538a1.018 1.018 0 01-1.011.957z",
  fill: "#3c00dc"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 284"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 364",
  d: "M3288.871 4615.367a1.018 1.018 0 01-1.018-1.008 27.633 27.633 0 00-1.072-6.917c-.588-2.174-1.368-4.386-2.056-6.337a1.018 1.018 0 011.919-.677c.7 1.985 1.493 4.235 2.1 6.482a29.63 29.63 0 011.142 7.428 1.018 1.018 0 01-1.007 1.028z",
  fill: "#3c00dc"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 285"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 365",
  d: "M3290.477 4615.369a1.018 1.018 0 01-.98-1.294 50.994 50.994 0 001.774-10.895 1.018 1.018 0 012.032.117 53.036 53.036 0 01-1.848 11.331 1.018 1.018 0 01-.978.741z",
  fill: "#3c00dc"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 286"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 366",
  d: "M3354.223 4668.886a1.018 1.018 0 01-1.017-.979c-.234-6.266-2.375-27.462-6.854-36.7a1.018 1.018 0 111.831-.888c4.62 9.525 6.819 31.135 7.057 37.51a1.018 1.018 0 01-.979 1.055z",
  fill: "#3c00dc"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 287"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 367",
  d: "M3339.095 4490.028a1.013 1.013 0 01-.621-.212c-2.552-1.971-5.826-5.178-6.93-9.259-.781-2.89 1.13-5.572 4.648-6.523a8.432 8.432 0 012.9-.269 1.018 1.018 0 01-.167 2.029 6.4 6.4 0 00-2.2.205c-2 .54-3.764 1.995-3.214 4.027.956 3.535 3.9 6.4 6.209 8.179a1.018 1.018 0 01-.623 1.823z",
  fill: "#3c00dc"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 288"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 368",
  d: "M3326.594 4496.313a1.018 1.018 0 01-.854-1.57 25.33 25.33 0 0110.117-9.153 1.018 1.018 0 11.873 1.839 23.274 23.274 0 00-9.28 8.419 1.017 1.017 0 01-.856.465z",
  fill: "#3c00dc"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 289"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 369",
  d: "M3310.625 4495.997a9.048 9.048 0 01-5.719-2.267 1.018 1.018 0 111.282-1.581c2 1.621 3.944 2.147 5.941 1.607a3.81 3.81 0 002.475-1.675 4.055 4.055 0 00.166-3.092c-.669-2.475-3.076-4.545-5.343-6.245a1.018 1.018 0 111.221-1.628c2.672 2 5.258 4.278 6.086 7.342a5.99 5.99 0 01-.357 4.621 5.823 5.823 0 01-3.718 2.642 7.772 7.772 0 01-2.034.276z",
  fill: "#3c00dc"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 290"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 370",
  d: "M3320.226 4490.071c-3.589 0-7.512-3.719-10.945-7.477a1.018 1.018 0 011.5-1.373c1.9 2.078 6.939 7.6 10.187 6.718a4.331 4.331 0 002.314-2.079 5.106 5.106 0 00.549-3.809c-.764-2.826-3.977-5.534-6.928-7.85a1.018 1.018 0 111.257-1.6c3.356 2.633 6.709 5.492 7.637 8.92a7.073 7.073 0 01-.741 5.34 6.247 6.247 0 01-3.556 3.043 4.878 4.878 0 01-1.274.167z",
  fill: "#3c00dc"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 291"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 371",
  d: "M997.716 199.383a1.019 1.019 0 01-1-.854 32.3 32.3 0 016.607-25.352 1.018 1.018 0 111.595 1.264 30.257 30.257 0 00-6.193 23.758 1.018 1.018 0 01-.839 1.169 1.07 1.07 0 01-.17.015z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 292"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 372",
  d: "M1006.989 170.775a1.018 1.018 0 01-.91-1.473 12.716 12.716 0 011.552-2.27 1.018 1.018 0 011.589 1.271 11 11 0 00-1.321 1.909 1.018 1.018 0 01-.91.563z",
  fill: "#fff"
}))));

function SvgCareersIllustrationinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1228.107,
    height: 548.835,
    viewBox: "0 0 1228.107 548.835"
  }, props), _ref, _ref2);
}

export default SvgCareersIllustrationinline;